export const MONTHS = [
  { value: 1, short: 'Jan', full: 'Janeiro' },
  { value: 2, short: 'Fev', full: 'Fevereiro' },
  { value: 3, short: 'Mar', full: 'Março' },
  { value: 4, short: 'Abr', full: 'Abril' },
  { value: 5, short: 'Mai', full: 'Maio' },
  { value: 6, short: 'Jun', full: 'Junho' },
  { value: 7, short: 'Jul', full: 'Julho' },
  { value: 8, short: 'Ago', full: 'Agosto' },
  { value: 9, short: 'Set', full: 'Setembro' },
  { value: 10, short: 'Out', full: 'Outubro' },
  { value: 11, short: 'Nov', full: 'Novembro' },
  { value: 12, short: 'Dez', full: 'Dezembro' },
];

const NAME_PARTICLES = ['da', 'das', 'de', 'do', 'dos', 'e'];

// "Exibir" da lista do mês (os mesmos valores do backend). Fora do mês atual, "Hoje" não tem ninguém
// e "Hoje e Próximos" mostra o mês inteiro
export const BIRTHDAY_DISPLAYS = [
  { value: 'TODAY', label: 'Hoje', empty: 'Nenhum aniversariante hoje.' },
  { value: 'UPCOMING', label: 'Hoje e Próximos', empty: 'Nenhum aniversariante de hoje até o fim do mês.' },
  { value: 'ALL', label: 'Todos', empty: 'Nenhum aniversariante neste mês.' },
];

export const DEFAULT_BIRTHDAY_DISPLAY = 'UPCOMING';

// Padrão do botão Parabenizar (o mesmo do backend, usado se a configuração não carregar)
export const DEFAULT_WHATSAPP_MESSAGE = 'Olá, {{primeiro_nome}}! A equipe *Ajust* deseja um feliz aniversário!';

// Paciente de exemplo das prévias
export const SAMPLE_NAME = 'MARIA DA SILVA';

// 'YYYY-MM-DD' -> 'DD/MM'
export function birthdayDayMonth(data_nascimento) {
  const [, month, day] = (data_nascimento || '').split('-');
  return (month && day) ? `${day}/${month}` : '';
}

// 'YYYY-MM-DD' -> 'DD/MM/YYYY' (sem passar por Date, que mudaria o dia no fuso)
export function dateBR(value) {
  const [year, month, day] = (value || '').split('-');
  return (year && month && day) ? `${day}/${month}/${year}` : '';
}

// Igual ao envio do e-mail: no 28/02 de ano não bissexto, quem nasceu em 29/02 também faz aniversário
export function isBirthdayToday(data_nascimento, today = new Date()) {
  const [, month, day] = (data_nascimento || '').split('-').map(Number);
  if (!month || !day) return false;

  const todayMonth = today.getMonth() + 1;
  const todayDay = today.getDate();
  if ((month === todayMonth) && (day === todayDay)) return true;

  const year = today.getFullYear();
  const isLeapYear = ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
  return !isLeapYear && (month === 2) && (day === 29) && (todayMonth === 2) && (todayDay === 28);
}

// "MARIA DA SILVA" -> "Maria da Silva" (mesma regra do e-mail)
export function formatName(nome) {
  return (nome || '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word, index) => {
      if ((index > 0) && NAME_PARTICLES.includes(word)) return word;
      return word.replace(/(^|[-'])(\p{L})/gu, (_, separator, letter) => separator + letter.toUpperCase());
    })
    .join(' ');
}

export function firstName(nome) {
  return formatName(nome).split(' ')[0] || '';
}

export function nameInitials(nome) {
  return (nome || '')
    .split(/\s+/)
    .filter((word) => word && !NAME_PARTICLES.includes(word.toLowerCase()))
    .slice(0, 2)
    .map((word) => word[0].toUpperCase())
    .join('') || '?';
}

// Celular para o WhatsApp, com o 55: primeiro o celular; o fixo só se tiver 11 dígitos (é celular)
export function whatsappNumber(paciente) {
  const normalize = (value, lengths) => {
    const digits = (value || '').replace(/\D/g, '');
    if (lengths.includes(digits.length)) return `55${digits}`;
    if (digits.startsWith('55') && lengths.includes(digits.length - 2)) return digits;
    return null;
  };

  return normalize(paciente?.telefone2, [10, 11]) || normalize(paciente?.telefone, [11]);
}

// Troca {{primeiro_nome}} e {{nome}} pelo nome do paciente (mesma regra do e-mail)
export function fillNames(text, nome = SAMPLE_NAME) {
  return (text || '')
    .replace(/{{primeiro_nome}}/g, () => firstName(nome))
    .replace(/{{nome}}/g, () => formatName(nome));
}

export function whatsappBirthdayLink(paciente, message = DEFAULT_WHATSAPP_MESSAGE) {
  const number = whatsappNumber(paciente);
  if (!number) return null;

  const text = fillNames((message || '').trim() || DEFAULT_WHATSAPP_MESSAGE, paciente.nome);
  return `https://wa.me/${number}?text=${encodeURIComponent(text)}`;
}
